import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React ,{useState} from "react";
import { useAddTaskMutation,useGetCourseListQuery,useGetLearningOutcomeListQuery} from "../../../Services/api";

export default function Create() {
    const notify = () => '';
    const { register, handleSubmit, formState: { errors }} = useForm();
    const [addTask,isLoading] = useAddTaskMutation();
    const onSubmit = (values,e) => {
        const formData = new FormData();
        formData.append('unit_id', values.lpid);
        formData.append('course_id', values.course_id);
        formData.append('start_date', values.start_date);
        formData.append('end_date',values.end_date);
        addTask( formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                 e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    const [courseCode,setCourseCode] = useState(0);
    const findLession=(e)=>{
        setCourseCode(e.target.value);
    }
    const { 
        data: LearningOutcomeList        
    } = useGetLearningOutcomeListQuery({  params:courseCode});
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Task Information</h5>
                        <form onSubmit={handleSubmit(onSubmit)} >
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                                <div className="col-sm-10">
                                <select  {...register("course_id", { required: true })} className="form-control" onChange={findLession}>
                                    <option value="">Select Course</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.course_id && <span  className="text-danger">Course is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element</label>
                                <div className="col-sm-10">
                                <select  {...register("lpid", { required: true })} className="form-control">
                                    <option value="">Select Element</option>                                           
                                    {                            
                                    LearningOutcomeList?.data?.map((item) => {
                                        return (
                                            <option key={item.lpid} value={item.lpid}>{item.element_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.lpid && <span  className="text-danger">Course is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Start Date</label>
                                <div className="col-sm-10">
                                    <input type="date" {...register("start_date" ,{ required: true})} className="form-control" />
                                    {errors.start_date && <span  className="text-danger">Start Date is required</span>}
                                </div>
                            </div>
                             <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">End Date</label>
                                <div className="col-sm-10">
                                    <input type="date" {...register("end_date" ,{ required: true})} className="form-control" />
                                    {errors.end_date && <span  className="text-danger">End Date is required</span>}
                                </div>
                            </div>
                          <div className="modal-footer">
                                
                                {isLoading.status !='pending' ? 
                                 <>
                                    <button type="submit" className="btn btn-warning">Save changes</button>
                                 </>     
                                :
                                <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div> 
                        
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}